var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M23.1818182,9.81818182 L12,9.81818182 L12,14.4545455 L18.4363636,14.4545455 C17.8363636,17.4 15.3272727,19.0909091 12,19.0909091 C8.07272727,19.0909091 4.90909091,15.9272727 4.90909091,12 C4.90909091,8.07272727 8.07272727,4.90909091 12,4.90909091 C13.6909091,4.90909091 15.2181818,5.50909091 16.4181818,6.49090909 L19.9090909,3 C17.7818182,1.14545455 15.0545455,0 12,0 C5.34545455,0 0,5.34545455 0,12 C0,18.6545455 5.34545455,24 12,24 C18,24 23.4545455,19.6363636 23.4545455,12 C23.4545455,11.2909091 23.3454545,10.5272727 23.1818182,9.81818182 Z",
  id: "path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.1818182,9.81818182 L12,9.81818182 L12,14.4545455 L18.4363636,14.4545455 C17.8363636,17.4 15.3272727,19.0909091 12,19.0909091 C8.07272727,19.0909091 4.90909091,15.9272727 4.90909091,12 C4.90909091,8.07272727 8.07272727,4.90909091 12,4.90909091 C13.6909091,4.90909091 15.2181818,5.50909091 16.4181818,6.49090909 L19.9090909,3 C17.7818182,1.14545455 15.0545455,0 12,0 C5.34545455,0 0,5.34545455 0,12 C0,18.6545455 5.34545455,24 12,24 C18,24 23.4545455,19.6363636 23.4545455,12 C23.4545455,11.2909091 23.3454545,10.5272727 23.1818182,9.81818182 Z",
  id: "path-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.1818182,9.81818182 L12,9.81818182 L12,14.4545455 L18.4363636,14.4545455 C17.8363636,17.4 15.3272727,19.0909091 12,19.0909091 C8.07272727,19.0909091 4.90909091,15.9272727 4.90909091,12 C4.90909091,8.07272727 8.07272727,4.90909091 12,4.90909091 C13.6909091,4.90909091 15.2181818,5.50909091 16.4181818,6.49090909 L19.9090909,3 C17.7818182,1.14545455 15.0545455,0 12,0 C5.34545455,0 0,5.34545455 0,12 C0,18.6545455 5.34545455,24 12,24 C18,24 23.4545455,19.6363636 23.4545455,12 C23.4545455,11.2909091 23.3454545,10.5272727 23.1818182,9.81818182 Z",
  id: "path-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.1818182,9.81818182 L12,9.81818182 L12,14.4545455 L18.4363636,14.4545455 C17.8363636,17.4 15.3272727,19.0909091 12,19.0909091 C8.07272727,19.0909091 4.90909091,15.9272727 4.90909091,12 C4.90909091,8.07272727 8.07272727,4.90909091 12,4.90909091 C13.6909091,4.90909091 15.2181818,5.50909091 16.4181818,6.49090909 L19.9090909,3 C17.7818182,1.14545455 15.0545455,0 12,0 C5.34545455,0 0,5.34545455 0,12 C0,18.6545455 5.34545455,24 12,24 C18,24 23.4545455,19.6363636 23.4545455,12 C23.4545455,11.2909091 23.3454545,10.5272727 23.1818182,9.81818182 Z",
  id: "path-7"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Google"
}, /*#__PURE__*/React.createElement("g", {
  id: "Google-Logo"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "a"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FBBC05",
  mask: "url(#mask-2)",
  points: "-1.09090909 19.0909091 -1.09090909 4.90909091 8.18181818 12"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "a"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EA4335",
  mask: "url(#mask-4)",
  points: "-1.09090909 4.90909091 8.18181818 12 12 8.67272727 25.0909091 6.54545455 25.0909091 -1.09090909 -1.09090909 -1.09090909"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "a"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#34A853",
  mask: "url(#mask-6)",
  points: "-1.09090909 19.0909091 15.2727273 6.54545455 19.5818182 7.09090909 25.0909091 -1.09090909 25.0909091 25.0909091 -1.09090909 25.0909091"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("g", {
  id: "a"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#4285F4",
  mask: "url(#mask-8)",
  points: "25.0909091 25.0909091 8.18181818 12 6 10.3636364 25.0909091 4.90909091"
})))))));
export { SvgGoogle as ReactComponent };
export default __webpack_public_path__ + "static/media/google.630b1f7b.svg";